import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

/**
 * Service to update user's run-it-twice preference
 * @param {object} data - object contains { runItTwicePreference: boolean }
 */
export const updateRunItTwicePreferenceService = (data) => {
  return axiosInstanceService(METHOD_TYPES.put, 'user/update-run-it-twice-preference', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const getUserInfoService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'user/user-detail', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const getTransactions = (data, endpoint) => {
  return axiosInstanceService(METHOD_TYPES.get, endpoint, data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    params: data

  })
}

export const generateServerSeedService = () => {
  return axiosInstanceService(METHOD_TYPES.post, 'user/generate-server-seed', {}, {
    server: microServices.SERVICE_URL_1
  })
}
